import type { FaireThemeEntity } from "../../entity_types/theme";

export const non_tarnish_waterproof_gems: FaireThemeEntity = {
  token: "non-tarnish-waterproof-gems",
  type: "theme",
  name: "Non-Tarnish Waterproof Gems",
  description: "Durable stainless steel jewelry for everyday wear -- tarnish-resistant and hypoallergenic.",
  teaser: "Tarnish-resistant pieces your active clients wear everywhere.",
  detail: "Your order history shows strong preference for Non-Tarnish and Water Resistant attributes. Nearly every item -- from the Eclaire necklace to the Moira ring -- highlights water resistance and hypoallergenic properties.",
  bgColor: "#EDE0F5",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
    "p_ar6ja253qt",
    "p_ykcapkuvqq",
    "p_7aj8n8fwkr",
    "p_5gefr7p29d",
    "p_9pm84vbjg7",
    "p_s5kj5vxsjg",
    "p_mrdc3wmdh2",
    "p_zbfwgazcex",
    "p_ychfn8hrk4",
    "p_bagjhpjgk4",
    "p_s64zjtkks2",
    "p_kdz9fw5mq5",
    "p_88qwxx7dga",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
